import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { videoSamplesList } from 'api/endpoints/video-sample';
import { videoCategoryList } from 'api/endpoints/video_category';
import Button from 'components/Button';
import LayoutMain from 'components/layouts/LayoutMain';
import { OPTION_PAGINATION } from 'constants/index';
import { TEXT_SAMPLE_VIDEO_LIST } from 'constants/string/texts';
import CreateSampleVideo from 'pages/SampleVideo/CreateSampleVideo/CreateSampleVideo';
import SampleVideoListHeader from 'pages/SampleVideo/List/SampleVideoHeader';
import SampleVideoPagination from 'pages/SampleVideo/List/SampleVideoPagination';
import SampleVideoTable from 'pages/SampleVideo/List/SampleVideoTable';
import { setModalSampleVideo } from 'store/actions/sample-video';
import { setVideoCategories } from 'store/actions/video-catergory';
import { convertToQueryString } from 'utils/helper';

const SampleVideo = () => {
  const { me } = useSelector((state) => state.auth);
  const { modalSampleVideo } = useSelector((state) => state.sampleVideo);
  const dispatch = useDispatch();
  const [options, setOptions] = useState({ video_category_id: null, ...OPTION_PAGINATION });
  const [sort, setSort] = useState([]);
  const [listSampleVideo, setListSampleVideo] = useState([]);
  const [loading, setLoading] = useState(false);

  // PAGINATION
  const onPageChange = (e) => {
    if (e !== options.page) {
      setOptions((prevState) => {
        return { ...prevState, page: e };
      });
      return true;
    }

    return false;
  };

  // SORT
  const onSortChange = (e) => {
    setSort(() => e);
  };

  // CATEGORY
  const onChangeCategory = (e) => {
    if (e !== options.video_category_id) {
      setOptions((prevState) => {
        return { ...prevState, ...e };
      });
    }
  };

  /**
   * @name handleSort
   * @returns {string[]}
   * @example ['created_at']
   * @example ['-created_at']
   */
  const handleSort = () => {
    return (
      sort.map((item) => {
        return item.desc ? `-${item.id}` : item.id;
      }) || []
    );
  };

  const handleGetSampleVideo = async () => {
    const sortHandle = handleSort().filter((item) => item !== 'link' && item !== '-link');
    const queryString = convertToQueryString({
      video_category_id: options.video_category_id,
      sort_by: sortHandle,
      page: options.page,
      page_size: 10,
    });
    setLoading(true);
    try {
      const response = await videoSamplesList(queryString);
      setListSampleVideo(response?.data || []);
      setOptions((prevState) => {
        return {
          ...prevState,
          total: response?.total || 0,
          page_size: response?.page_size || 10,
          page: response?.page || 1,
        };
      });
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  // GET DATA
  const getSampleVideo = useCallback(async () => {
    if (me) {
      handleGetSampleVideo();
    }
  }, [options.page, options.video_category_id, sort, me]);

  useEffect(() => {
    getSampleVideo();
  }, [getSampleVideo]);

  const getVideoCategoryList = useCallback(async () => {
    if (me) {
      try {
        const res = await videoCategoryList();
        const data = res.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        dispatch(setVideoCategories(data));
      } catch {
        dispatch(setVideoCategories([]));
      }
    }
  }, [me]);

  useEffect(() => {
    getVideoCategoryList();
  }, [getVideoCategoryList]);

  return (
    <>
      <LayoutMain className={'!max-w-1720'}>
        <section id="question-list">
          <div className="flex items-center justify-between gap-2 mt-2">
            <h1 className="text-2xl font-bold text-black/85">{TEXT_SAMPLE_VIDEO_LIST.TITLE}</h1>
            <Button
              onClick={() => {
                dispatch(setModalSampleVideo({ isOpen: true, isEdit: false }));
              }}
              color="primary"
              text={TEXT_SAMPLE_VIDEO_LIST.CREATE_SAMPLE_VIDEO}
              className="w-[260px] h-9.5"
              icon={<img src={require('assets/resources/Plus.svg').default} alt="plus icon" width={18} height={18} />}
            />
          </div>
          <SampleVideoListHeader options={options} onChange={onChangeCategory} />
          <div className={`w-full mt-4 ${options.total > 0 ? 'min-h-164.75' : ''}`}>
            <SampleVideoTable
              data={listSampleVideo}
              setSort={onSortChange}
              reloadData={handleGetSampleVideo}
              onPageChange={onPageChange}
              sort={sort}
              page={options.page}
            />
          </div>
          {options.total > 0 && <SampleVideoPagination options={options} onPageChange={onPageChange} loading={loading} />}
        </section>
      </LayoutMain>
      {modalSampleVideo.isOpen && <CreateSampleVideo reloadData={handleGetSampleVideo} />}
    </>
  );
};

export default React.memo(SampleVideo);
